export default "__VITE_ASSET__7maHxQM7__"